import { createApp } from "vue"
import VirtualScroller from "vue-virtual-scroller"
import router, { renderRoutes } from "@/router/index"
import pinia from "@/stores"
import i18n from "@/i18n/index"
import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
import getTailwindConfig from "@/plugins/checkTailwindConfig"
import setFontSizeConfig from "@/plugins/fontSizeConfig"
import loadCustomSetting from "@/plugins/loadCustomSetting"
import stopDoubleTap from "@/plugins/stopDoubleTap"
import { plugin as dayjsConfigPlugin } from "@/plugins/dayJsConfig"
import { isMobile } from "@common_lib/base/utils/src/tools"

import { setWindowTitle, setQueryPass, setCertification } from "@/plugins/setWebsiteInfo"
import initSentry from "@/plugins/sentry"
import App from "./App.vue"

const checkIsMobileAndRedirect = () => {
  return new Promise((resolve, reject) => {
    if (import.meta.env.PROD && import.meta.env.MODE !== "dev-nginx" && !isMobile()) {
      const newUrl = import.meta.env.VITE_BASE_API_URL
        ? `${import.meta.env.VITE_BASE_API_URL}`
        : `${window.location.protocol}//${window.location.host.replace(
            /^[^.]*/,
            import.meta.env.VITE_BASE_API_SUBDOMAIN
          )}`

      window.location.href = newUrl
      reject()
    } else {
      resolve()
    }
  })
}

const execute = async () => {
  try {
    await checkIsMobileAndRedirect()

    const app = createApp(App)

    app.use(i18n)
    app.use(VirtualScroller)
    app.use(pinia)

    const websiteInfoStore = useWebsiteInfoStore()
    const { getInitInfo } = websiteInfoStore

    setQueryPass()
    setCertification()
    dayjsConfigPlugin()
    stopDoubleTap()
    getTailwindConfig()
    setFontSizeConfig()

    getInitInfo()
      .then(res => {
        renderRoutes(router, { optional: res })

        setWindowTitle(res.webSiteDisplayName)
        loadCustomSetting(res.webSiteCssName)
        initSentry({ app, router })
      })
      .catch(err => {
        renderRoutes(router, { optional: {} })
        console.error("Unexpected error:", err)
      })
      .finally(() => {
        app.use(router)
        app.mount("#app")
      })
  } catch (err) {
    console.log("redirect")
  }
}

execute()
